import React,{ Component } from "react";
import { createStore, compose, applyMiddleware } from "redux";
import { Provider } from "react-redux";
import { CookiesProvider } from "react-cookie";
// import { BrowserRouter } from "react-router-dom";
import { Router } from "react-router-dom";
import ReduxThunk from "redux-thunk";
import { composeWithDevTools } from "redux-devtools-extension";
import "./index.css";

import history from "./history";

import rootReducer from "./modules";
import { rawDataWithRoutineKey, sendedFromHiClass } from "./lib/EoBrowserRcvUtil";

import App from "./App";

class HiclassTV extends Component {

    store = createStore(rootReducer,
        compose(composeWithDevTools(applyMiddleware(ReduxThunk)), window.devToolsExtension ? window.devToolsExtension() : f => f));

    sendRawDataWithRoutinKey = (rawData, routingKey) => {
        console.log("sendRawDataWithRoutinKey - routingKey => ", routingKey);
        rawDataWithRoutineKey(this.store, rawData, routingKey, false);
    }

    sendWhisperData = (rawData, routingKey) => {
        console.log("sendWhisperData - routingKey => ", routingKey);
        rawDataWithRoutineKey(this.store, rawData, routingKey, true);
    }

    // sendGroupChatData = (rawData, routingKey) => {
    //     console.log("sendGroupChatData - routingKey => ", routingKey);
    //     rawDataWithRoutineKey(this.store, rawData, routingKey, true);
    // }

    sendedDataFromHiClass = (sendKind, sendData) => {
        sendedFromHiClass(this.store, sendKind, sendData);
    }

    render() {
        return (
            <Provider store={this.store}>
                <CookiesProvider>
                    <Router history={history}>
                        <App />
                    </Router>
                </CookiesProvider>
            </Provider>
        );
    }
}

export default HiclassTV;